import React from 'react';
import { AudioInputFailed } from '@shoflo/polymer/containers/modals/AudioInputFailed/AudioInputFailed';
import CreateMeetingError from '@shoflo/polymer/containers/modals/CreateMeetingError/CreateMeetingError';
import LoadBroadcastError from '@shoflo/polymer/containers/modals/LoadBroadcastError/LoadBroadcastError';
import { MeetingEndedModal } from '@shoflo/polymer/containers/modals/MeetingEnded/MeetingEnded';
import { TokenValidationError } from '@shoflo/polymer/containers/modals/TokenValidationError/TokenValidationError';
import { UnauthorizedError } from '@shoflo/polymer/containers/modals/UnauthorizedError/UnauthorizedError';
import UploadErrorForm from '@shoflo/polymer/containers/modals/UploadErrorForm/UploadErrorForm';

import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';

import PresenterSettings from 'containers/modals/PresenterSettings/PresenterSettings';
import GenericPresenterSettings from 'containers/modals/PresenterSettings/GenericPresenterSettings';
import SourceFormModal from 'containers/modals/SourceForm/SourceForm';
import MediaPicker from 'containers/modals/MediaPicker/MediaPicker';
import BackgroundPicker from 'containers/modals/BackgroundPicker/BackgroundPicker';
import BackgroundChooser from 'containers/modals/BackgroundChooser/BackgroundChooser';
import BackgroundForm from 'containers/modals/BackgroundForm/BackgroundForm';
import LostRealtimeSocketMessage from 'containers/modals/LostRealtimeSocketMessage/LostRealtimeSocketMessage';

import AssignSpeakers from './containers/modals/AssignSpeakers/AssignSpeakers';
import { GenericSourceSettings } from './containers/modals/SourceSettings/GenericSourceSettings';
import { SourceSettings } from './containers/modals/SourceSettings/SourceSettings';

function AppModals() {
  return (
    <>
      <PresenterSettings />
      <GenericPresenterSettings />
      <SourceFormModal />
      <MediaPicker />
      <BackgroundChooser />
      <BackgroundPicker />
      <BackgroundForm />
      <MeetingEndedModal />
      <AudioInputFailed />
      <LoadBroadcastError />
      <CreateMeetingError />
      <UnauthorizedError />
      <UploadErrorForm clearModal={clearModal} />
      <LostRealtimeSocketMessage />
      <AssignSpeakers />
      <SourceSettings />
      <GenericSourceSettings />
      <TokenValidationError />
    </>
  );
}

export default AppModals;
